import { render } from "./FlightProvide.vue?vue&type=template&id=5177a5d8"
import script from "./FlightProvide.vue?vue&type=script&lang=js"
export * from "./FlightProvide.vue?vue&type=script&lang=js"
script.render = render

export default script